
// google-maps-config.js

import { Loader } from '@googlemaps/js-api-loader';

// Replace with your actual Google Maps API key
const GOOGLE_MAPS_API_KEY = process.env.VUE_APP_GOOGLE_MAPS_API_KEY;

const loader = new Loader({
  apiKey: GOOGLE_MAPS_API_KEY,
  version: 'weekly',
  libraries: ['drawing'], // Ensure the drawing library is loaded
});

export default loader;
